export class FilterTaskRequestModel {
    siteURL:string;
    taskApprovalStatus:number;
}
